import type { EntityProcessInfo } from 'types';

export function processIdSelector(context: EntityProcessInfo) {
	const { agreementProcessId = '' } = context?.processInfo || {};
	return agreementProcessId;
}
